import Vue from 'vue'
import VueRouter from 'vue-router'

// register the VueRouter
Vue.use(VueRouter)

// route definitions
import routes from './routes'

const appRouter = new VueRouter({
  'mode': 'history',
  'routes': routes
})

export {landingPage, loginPage, mainPage} from './routes'
export const router = appRouter
export {getFirstRoute} from './workflow'
export default appRouter

// Register the default authGuard
import authGuard from './authGuard'
import profileGuard from './profileGuard'

appRouter.beforeEach(authGuard)
appRouter.beforeEach(profileGuard)



// WEBPACK FOOTER //
// ./src/router/index.js